exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer-link-block__title{display:block;margin-bottom:12.5px;padding:0!important;font-size:18px;line-height:24px;font-weight:500}a.footer-link-block__title{color:#fff;text-decoration:none}.footer-link-block__links{margin:0;padding:0;list-style:none}.footer-link-block__links>li:not(:last-child){margin-bottom:5px}.footer-link-block__links>li>a{font-size:14px;line-height:18px;color:#fff;text-decoration:none;opacity:.8;transition:opacity .3s ease}.footer-link-block__links>li>a:hover{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/containers/footer/footer-link-block/footer-link-block.styl
// module id = 482
// module chunks = 0